import React from "react";
import {FIELD_TYPE} from "types/enums";
import {formatDateToString, formatToCurrencyTypeToFixed} from "helper/common";
import StatusCard from "../../../StatusCard/StatusCard";

const {INPUT, DATE, COMBO_BOX, AUTO_COMPLETE, NUMBER, CURRENCY} = FIELD_TYPE;

const allColumns: any[] = [
  {
    key: "index",
    title: "STT",
    show: true,
    dataIndex: "index",
    render(value, record, index) {
      return <>{index + 1}</>;
    },
    fixed: "left",
    width: 40,
    align: "center",
    disabledCheck: true,
  },
  {
    key: "code",
    title: "Mã thuốc",
    show: false,
    dataIndex: "thuocId",
    width: 80,
    align: "center",
  },
  {
    title: "Kho",
    key: "kho",
    show: false,
    dataIndex: "kho",
    width: 150,
  },
  {
    title: "Số lô",
    key: "soLo",
    show: true,
    dataIndex: "soLo",
    width: 150,
    align: "left",
  },
  {
    title: "Tên thuốc",
    key: "tenThuoc",
    show: true,
    dataIndex: "tenThuoc",
    width: 120,
  },
  {
    title: "QĐ Thầu",
    key: "quyetDinhThau",
    show: true,
    dataIndex: "quyetDinhThau",
    width: 120,
  },
  {
    title: "Đơn vị tính",
    key: "unit",
    show: false,
    dataIndex: "donViTinh",
    width: 90,
    align: "center",
  },
  {
    title: "Nguồn thuốc",
    key: "nhomThuoc",
    show: false,
    dataIndex: "nhomThuoc",
    width: 120,
  },
  {
    title: "Dược chính",
    key: "duocChinh",
    show: false,
    dataIndex: "duocChinh",
    width: 120,
  },
  {
    title: "Hoạt chất",
    key: "hoatChat",
    show: false,
    dataIndex: "hoatChat",
    width: 120,
  },
  {
    title: "Dạng bào chế",
    key: "baoChe",
    show: false,
    dataIndex: "baoChe",
    width: 120,
  },
  {
    title: "SL tồn",
    key: "leftNumber",
    show: true,
    dataIndex: "tonKho",
    align: "right",
    render(value, record, index) {
      return <>{value > 0 ? value : 0}</>;
    },
    width: 60,
  },
  {
    title: "Đơn giá nhập (VNĐ)",
    key: "donGiaNhap",
    show: true,
    dataIndex: "donGiaNhap",
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyTypeToFixed(value, 2)}</>;
    },
    width: 100,
  },
  {
    type: CURRENCY,
    title: "Đơn giá bán (VNĐ)",
    key: "donGiaXuat",
    show: true,
    dataIndex: "donGiaXuat",
    align: "right",
    editable: true,
    render(value, record, index) {
      return <>{formatToCurrencyTypeToFixed(value, 2)}</>;
    },
    width: 100,
  },
  {
    title: "Số lô nhà sản xuất",
    key: "soLoNCC",
    show: true,
    dataIndex: "soLoNCC",
    width: 150,
    align: "left",
  },
  {
    title: "Giá trị hàng (VNĐ)",
    key: "giaTriHang",
    show: false,
    dataIndex: "giaTriHang",
    align: "right",
    render(value) {
      return <>{formatToCurrencyTypeToFixed(value, 2)}</>;
    },
    width: 120,
  },
  {
    title: "VAT (%)",
    key: "vat",
    show: false,
    dataIndex: "vat",
    align: "right",
    width: 40,
  },

  {
    title: "Ngày nhập",
    key: "createDate",
    show: false,
    dataIndex: "createDate",
    render(value, record, index) {
      return <>{value ? formatDateToString(value) : null}</>;
    },
    width: 90,
    align: "center",
  },
  {
    title: "Ngày sản xuất",
    key: "ngaySanXuat",
    show: false,
    dataIndex: "ngaySanXuat",
    render(value, record, index) {
      return <>{value ? formatDateToString(value) : null}</>;
    },
    width: 90,
    align: "center",
  },
  {
    title: "Ngày hết hạn",
    key: "ngayHetHan",
    show: true,
    dataIndex: "ngayHetHan",
    align: "center",
    render(value, record, index) {
      return <>{value ? formatDateToString(value) : null}</>;
    },
    width: 90,
  },
  {
    title: "Tình trạng",
    key: "status",
    show: true,
    dataIndex: "tinhTrang",
    width: 90,
    align: "center",
    render(value, record, index) {
      return <StatusCard status={value}></StatusCard>;
    },
  },

  {
    title: "SL đã xuất",
    key: "soLuongDaXuat",
    show: false,
    dataIndex: "soLuongDaXuat",
    align: "center",
    render(value, record, index) {
      return <>{value > 0 ? value : 0}</>;
    },
    width: 60,
  },
  {
    title: "SL dự trù",
    key: "soLuongDuTru",
    show: true,
    dataIndex: "soLuongDuTru",
    align: "right",
    render(value, record, index) {
      return <>{value > 0 ? value : 0}</>;
    },
    width: 60,
  },
  {
    type: NUMBER,
    title: "SL xuất dự kiến",
    key: "xuatDuKien",
    show: true,
    dataIndex: "xuatDuKien",
    align: "center",
    fixed: "right",
    editable: true,
    width: 60,
  },
  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    show: true,
    align: "center",
    fixed: "right",
    width: 80,
  },
];

const itemsInputField: any[] = [
  // {
  //   type: INPUT,
  //   placeholder: "Nhập",
  //   label: "Mã thuốc",
  // },
  {
    type: AUTO_COMPLETE,
    name: "ten-thuoc",
    label: "Tên thuốc",
  },
  // {
  //   type: SELECT,
  //   name: "ten-thuoc",
  //   label: "Đơn vị tính",
  // },
  {
    type: INPUT,
    name: "nguon-thuoc",
    label: "Nguồn thuốc",
  },
  // {
  //   type: SELECT,

  //   label: "Danh mục",
  // },
  {
    type: COMBO_BOX,
    name: "kho-id",
    label: "Kho thuốc",
    allowClear: false,
  },
  {
    type: COMBO_BOX,
    name: "tinh-trang",
    label: "Tình trạng hạn sử dụng",
    options: [
      {
        value: "Bình thường",
        label: "Bình thường",
      },
      {value: "Hết hạn", label: "Hết hạn"},
      {value: "Gần hết hạn", label: "Gần hết hạn"},
      {value: "Hết", label: "Hết"},
    ],
  },
  {
    type: DATE,
    name: "start",
    label: "Từ ngày",
  },
  {
    type: DATE,
    name: "end",
    label: "Đến ngày",
  },
  // {
  //   type: INPUT,
  //   name: "hoat-chat",
  //   label: "Tên hoạt chất",
  // },
];

export {allColumns, itemsInputField};
